import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { FiTrash2, FiEdit } from "react-icons/fi";
import { TbClipboardCheck, TbLoader } from "react-icons/tb";
import { MdOutlineQrCode2 } from "react-icons/md";
import BadgePills from "../../../../components/BadgePills";
import { NumericFormat } from 'react-number-format';
import Usuarios from '../../PerfilAgente/components/Usuarios'
import ListOptionsEstatus from "../../../../helpers/ListOptionsEstatus";
import "react-datepicker/dist/react-datepicker.css";
import ModalEditSolicitud from "./ModalEditSolicitud";

import { 
  getAllSolicitud, 
  deleteOneSolicitud, 
  getMiAgenciaAduanal, 
  getQRcode } 
  from "../../../../helpers/Api"
import TabAgenteOptions from "../../PerfilAgente/TabAgenteOptions";

const ListaDeAplicaciones = () => {
  
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');
  const idAgencia = localStorage.getItem('agencia');
  const location = useLocation();
  const [data, setData] = useState([]);
  const [referencia, setReferencia] = useState('');
  const [idSolicitudEdit, setIdSolicitudEdit] = useState('');
  const [totalDeuda, setTotalDeuda] = useState(0);
  
  const [fechaInicio, setFechaInicio] = useState(null);
  const [fechaFinal, setFechaFinal] = useState(null);
  const [estatus, setEstatus] = useState('');
  const [convenio, setConvenio] = useState('');
  const [solicitudesPendientes, setSolicitudesPendientes] = useState(0);

  //Modals
  const [modalIsOpen, setIsOpen] = useState(false);
    
    //Convenio de Colaboracion
    const aplicaConvenio = [
      { value: true, label: "Aplica convenio" },
      { value: false, label: "No aplica convenio" },
    ];

      //pagination
  const itemsPerPage = 10;
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

   
  useEffect(() => {
    getSolicitudes();
    handlerGetTotalDeuda();
  }, [referencia, 
    fechaInicio, 
    fechaFinal, 
    estatus, 
    convenio,
    itemOffset,
    modalIsOpen,
  ])


  const formatDate = (date) => {
    if (!date) return '';
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
  };


  const getSolicitudes = async () => {
    try {
      const response = await getAllSolicitud(
        itemsPerPage,
        itemOffset,
        referencia, 
        formatDate(fechaInicio), 
        formatDate(fechaFinal), 
        idAgencia, 
        estatus, 
        convenio, 
        token,
        "-fecha_creacion");
      if (response) {
         response?.count === itemsPerPage
          ? setPageCount(1)
          : setPageCount(Math.ceil(response?.count / itemsPerPage));
        setData(response.results);
        setSolicitudesPendientes(response.count);
      }
    } catch (error) {
      throw error
    } finally {
      setLoading(false);
    }
  };

  const handlerGetTotalDeuda = async () => {
    try {
      const response = await getMiAgenciaAduanal(idAgencia, token);
      if(response){
        setTotalDeuda(response?.total_deuda)
      }
    } catch (error) {
      throw error
    }
  }

  const handlerReferenciaSearch = (e) => {
    setReferencia(e.target.value);
  };


  const handlerDate = (dates) => {
    const [fechaInicio, fechaFinal] = dates;
    setFechaInicio(fechaInicio);
    setFechaFinal(fechaFinal);
  };

  const handlerEstatus = (e) => {
    setEstatus(e === null ? '' : e.value);
  };

  const handlerConvenio = (e) => {
    setConvenio(e === null ? '' : e.value);
  };

  const handlePageClick = (event) => {
    setItemOffset(event.selected * itemsPerPage);
  };

  //modals
  const openModal = () => {
    setIsOpen(true);
    };
    const closeModal = () => {
    setIsOpen(false);
    };

   const openModalToEdit = (id) =>{
    setIdSolicitudEdit(id);
    openModal()
   } 
  

  const handlerDeleteSolicitud = async (idSolicitud) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Una vez eliminado, no podrás recuperar esta referencia",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await deleteOneSolicitud(idSolicitud, token);
          if (!response) {
            Swal.fire("Exito", "La solicitud ha sido borrada exitosamente ", "success");
            getSolicitudes();
          }
        } catch (error) {
          Swal.fire(
            "Oops",
            "Ha surgido un problema al eliminar la referencia",
            "error"
          );
        }
      }
    });
  };


  return (
    <div className="row table_body">
    { loading ? (
      <div className="d-flex justify-content-center" style={{marginTop: '4rem'}}>
          <TbLoader color={'rgb(10, 132, 254)'} className="loader" size={'3rem'}/>
      </div>
     ) : (
      <>
      <div className="row table_searchers">
      {location.pathname !== '/miembro-aaapver' ?
      <>
      <div className="col-4">
        <TabAgenteOptions />
        </div>
        <div className="col-8 d-flex justify-content-end">
          <Link to='/crear-solicitud'>
            <button className="btn principal_button_blue">+ Crear Solicitud</button>
          </Link>
        </div>
        </>
        :
        <div className="col-3">
          <Link to='/crear-perfil-agente'>
            <button className="btn principal_button_blue">+ Registrar Agente Aduanal</button>
          </Link>
        </div>
      }
        {location.hash === '#solicitudes' &&
        <>
        <hr style={{ borderTop: "dotted 1px" }} />
        <div className="col-3">
            <input
              className="form-control"
              type="search"
              value={referencia}
              onChange={handlerReferenciaSearch}
              placeholder="Buscar solicitudes por referencia"
              aria-label="Search"
              style={{ width: "100%" }}
            />
        </div>
        <div className="col-3">
          <Select
            className="basic-single"
            classNamePrefix="select"
            placeholder={"Filtro por convenio"}
            options={aplicaConvenio}
            onChange={(e) => handlerConvenio(e)}
            isClearable={true}  
          />
        </div>

        <div className="col-3">
          <Select
            className="basic-single"
            classNamePrefix="select"
            name="color"
            options={ListOptionsEstatus}
            onChange={(e) => handlerEstatus(e)}
            placeholder={"Filtro por estatus"}
            isClearable={true}  
          />
        </div>

        <div className="col-3">
        <DatePicker
          className="form-control"
          selected={fechaInicio}
          onChange={handlerDate}
          startDate={fechaInicio}
          endDate={fechaFinal}
          selectsRange
          dateFormat='dd/MM/yyyy'
          isClearable={true}
          placeholderText="Buscar por fecha"
        />
        </div>
        <hr style={{ borderTop: "dotted 1px", marginTop: "1rem" }} />
        </>        
        }
      </div>
      { location.hash === '#usuarios' ?
      <div className="col-12">
      <Usuarios />
      </div>
      :
      <>
      <div className="col-12 table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">Referencia</th>
              <th scope="col">Bill of Landing</th>
              <th scope="col">Fecha de creación</th>
              <th scope="col">Naviera</th>
              <th scope="col">Contenedores</th>
              <th scope="col">Deuda (USD)</th>
              <th scope="col">Estatus</th>
              <th scope="col" style={{textAlign: 'center'}}>Acciones</th>
            </tr>
          </thead>
        {data?.map((value, index) => (  
          <tbody key={index}>
            <tr>
              <td style={{paddingTop: '3rem'}}>
              {value?.referencia}
              </td>
              <td style={{paddingTop: '3rem'}}>
              {value?.numero_bl}
              </td>
              <td style={{paddingTop: '3rem'}}>
              {value?.fecha_creacion}
              </td>
                <td style={{paddingTop: '3rem'}}>{value?.naviera_nombre}</td>
                <td style={{paddingTop: '3rem'}}>{value?.cantidad_contenedores_entregados} de {value?.cantidad_contenedores}</td>
                <td style={{paddingTop: '3rem'}}>
                <NumericFormat 
                prefix={"$"} 
                decimalSeparator={"."}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                displayType="text" 
                value={value?.total_demoras_pendiente
} 
                />
                </td>
                <td style={{paddingTop: '3rem'}}><BadgePills status={value.estado}/></td>
                <td className="d-flex flex-row" style={{height: '8.1rem'}}>
              
              {/* Button eliminated to avoid the deletion of the data by the user" */}
              
              {/* <button
              style={{ color: "#F34949" }}
              className="btn d-flex align-items-center"
              onClick={() => handlerDeleteSolicitud(value.id)}
              >
              <FiTrash2 />
              </button> */}
              
              <Link className="btn d-flex align-items-center" 
              onClick={() => openModalToEdit(value.id)}>
                <FiEdit />
              </Link>
              <a
              className='btn'
              style={{
                fontSize: '1.2rem',
                marginTop: '2rem'
              }}
              href='#'  // Note: Set a dummy value for href
              onClick={(e) => {
                e.preventDefault(); // Prevent the default link behavior
                fetch(`${process.env.REACT_APP_API}/pdf-qr/${value.id}/`, {
                  headers: {
                    Authorization: `Token ${token}`,
                  }
                })
                  .then(response => response.blob())  // You might want to handle the response differently based on your needs
                  .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    window.open(url, '_blank');
                  })
                  .catch(error => console.error('Error:', error));
              }}
              target='_blank'
              rel='noopener noreferrer'
            >
              <MdOutlineQrCode2 />
            </a>
              <Link className="btn d-flex align-items-center" to={`/detalle-operaciones/${value.id}/#contenedores`}>
                <TbClipboardCheck size={'1.2rem'} color={"#4516FF"}/>
              </Link>
              </td>
            </tr>
          </tbody>
        ))}
        </table>
      </div>
      <div className='col-12 mt-2 d-flex flex-row-reverse'>
       <NumericFormat
          prefix={"$"}
          decimalSeparator={"."}
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale={true}
          displayType="text"
          value={totalDeuda}
          />
          <p><b>Total de Demoras:</b></p>
      </div>
      <ModalEditSolicitud 
        modalIsOpen={modalIsOpen} 
        closeModal={closeModal}
        idSolicitudEdit={idSolicitudEdit}  
        />
      <div className="row">
         <div className="col-12" style={{textAlign: 'center', marginTop: '2rem'}}>
            <p>Total de registros: {solicitudesPendientes}</p>
          </div>
          <div className="col-12 d-flex justify-content-end paginationList">
            <ReactPaginate
              breakLabel="..."
              nextLabel="Siguiente"
              onPageChange={handlePageClick}
              pageRangeDisplayed={10}
              pageCount={pageCount}
              previousLabel="Anterior"
              renderOnZeroPageCount={null}
              containerClassName="pagination my-5 mx-auto"
              subContainerClassName="pages pagination"
              activeClassName="active"
              breakClassName="break-me"
              className="pagination"
            />
          </div>
        </div>

        </>
          }

        </>
      )}
    </div>
  );
};

export default ListaDeAplicaciones;
